/* Polaroid stack: cycles the top card to the back of the deck.
   Without JS or with prefers-reduced-motion the markup stays a scattered
   grid (styled in moment-custom.css), so nothing is ever hidden. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var stages = document.querySelectorAll('polaroid-stack');
  stages.forEach(function (stage) {
    var cards = Array.prototype.slice.call(stage.querySelectorAll('.moment-polaroid'));
    if (cards.length < 2) return;

    stage.classList.add('is-stacked');
    stage.parentElement.classList.add('moment-polaroids--stacked-layout');
    var hint = stage.parentElement.querySelector('.moment-polaroids__hint');
    if (hint) hint.hidden = false;

    var order = cards.slice();
    var interval = parseInt(stage.getAttribute('data-interval'), 10) || 4000;
    var timer = null;
    var animating = false;

    function layout() {
      order.forEach(function (card, pos) {
        card.style.zIndex = String(order.length - pos);
        card.setAttribute('data-pos', pos < 4 ? String(pos) : 'deep');
      });
    }

    function advance() {
      if (animating) return;
      animating = true;
      var top = order.shift();
      order.push(top);
      top.setAttribute('data-pos', 'exit');
      window.setTimeout(function () {
        layout();
        animating = false;
      }, 420);
    }

    function play() {
      stop();
      timer = window.setInterval(advance, interval);
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    stage.addEventListener('click', function () {
      advance();
      play(); // restart the clock so a click doesn't double-advance
    });
    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', play);

    // only run while on screen
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play();
        else stop();
      });
    });
    io.observe(stage);

    layout();
  });
})();
